module.exports = __webpack_public_path__ + "img/case-logo-12.f7bedbda.png";